import { actionTypes, errorTypes } from '@/types';

export default function isMapAvailable(id, getters, state, dispatch) {
	if (id !== 'ui--map') return true;
	if (
		// 1) Exhibition online map
		getters.currentExhibition.hasOnlineNavigationMap ||
		// 2) Exhibition custom map
		getters.currentExhibition.customMap ||
		// 3) DataSource online map
		state.dataSourceCFG.global.hasOnlineNavigationMap ||
		// 4) DataSource custom map
		state.dataSourceCFG.global.customMap
	) {
		return true;
	}
	dispatch(actionTypes.sendErrorMessage, { error: new Error(errorTypes.mapNotConfigured) });
}
